
import React from 'react';

const ContactMap: React.FC = () => {
  return (
    <section className="section-padding bg-white">
      <div className="container-custom">
        <div className="text-center mb-12 fade-in-up">
          <h2 className="text-3xl md:text-4xl font-bold text-primary-brand mb-6">
            So finden Sie uns
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
            Besuchen Sie uns in unserem Büro in Aschheim. Wir freuen uns auf ein persönliches Gespräch über Ihr Bauprojekt.
          </p>
        </div>
        
        <div className="fade-in-up-delay max-w-6xl mx-auto">
          <div className="bg-white p-8 rounded-2xl shadow-elegant border border-gray-200">
            <div className="aspect-[21/9] w-full rounded-xl overflow-hidden">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2661.5!2d11.7!3d48.17!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x479e755a1b2c3d4e%3A0x5f6789abcd123456!2sMax-Planck-Str.%204%2C%2085609%20Aschheim%2C%20Germany!5e0!3m2!1sen!2sus!4v1234567890"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="AMMING GmbH Standort"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactMap;
